"use client";

import React from "react";
import classNames from "classnames";

const steps = [
  { id: 1, label: "Details" },
  { id: 2, label: "Availability" },
  { id: 3, label: "Media" },
  { id: 4, label: "Review" },
];

export default function StepperHeader({ currentStep }) {
  return (
    <div className="w-full flex flex-col items-center mt-10 mb-12">
      {/* WRAPPER */}
      <div className="relative w-full max-w-[900px] flex items-center justify-between">
        {/* FULL BACKGROUND LINE */}
        <div className="absolute left-0 right-0 top-1/2 h-[1px] bg-black -translate-y-1/2 z-0" />

        {/* STEPS */}
        {steps.map((step, index) => {
          const isActive = currentStep === step.id;
          const isCompleted = currentStep > step.id;

          return (
            <div
              key={step.id}
              className="relative z-10 flex flex-col items-center flex-1"
            >
              {/* WHITE MASK (gap in line) */}
              <div className="absolute top-1/2 -translate-y-1/2 w-[90px] h-[90px] bg-white rounded-full z-0" />

              {/* CIRCLE */}
              <div
                className={classNames(
                  "relative z-10 flex items-center justify-center rounded-full",
                  "w-[52px] h-[52px] text-[18px] font-semibold transition-all",
                  isActive
                    ? "bg-[#00C3CC] text-white"
                    : isCompleted
                      ? "bg-[#1FADC6] text-white"
                      : "bg-[#F2F2F2] text-black",
                )}
              >
                {step.id}
              </div>
            </div>
          );
        })}
      </div>

      {/* LABELS */}
      <div className="mt-4 w-full max-w-[900px] flex justify-between px-2">
        {steps.map((step) => {
          const isActive = currentStep === step.id;

          return (
            <div key={step.id} className="text-center flex-1">
              <span
                className={classNames(
                  "text-[15px] font-medium block transition",
                  isActive ? "text-black" : "text-[#555]",
                )}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
